import React, { useState, useEffect, useRef, lazy } from 'react';

const LazyPerformanceLevelsModal = lazy(
  () =>
    import(
      /* webpackChunkName: "aware-perf-levels" */ '@aware/modals/performance-levels/performance-levels-modal'
    )
);

export const usePerformanceLevelsModal = () => {
  const iframeRef = useRef();
  const [levelsModal, setLevelsModal] = useState();

  useEffect(() => {
    window.top.showPerformanceLevelsModal = id => setLevelsModal(id);
    return () => delete window.top.showPerformanceLevelsModal;
  }, []);

  return {
    iframeRef,
    modal: levelsModal && (
      <LazyPerformanceLevelsModal
        id={levelsModal}
        onClose={() => {
          setLevelsModal(false);
          iframeRef.current?.contentDocument
            ?.querySelector('#detailsec1')
            ?.contentDocument.location.reload();
        }}
      />
    )
  };
};
